document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll<HTMLElement>('.faq-item')
  if (!items.length) return

  for (const item of items) {
    const btn    = item.querySelector<HTMLButtonElement>('.faq-question')
    const answer = item.querySelector<HTMLElement>('.faq-answer')
    if (!btn || !answer) continue

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open')

      // Fecha todos
      for (const other of items) {
        other.classList.remove('open')
        const otherBtn    = other.querySelector<HTMLButtonElement>('.faq-question')
        const otherAnswer = other.querySelector<HTMLElement>('.faq-answer')
        if (otherBtn)    otherBtn.setAttribute('aria-expanded', 'false')
        if (otherAnswer) otherAnswer.setAttribute('hidden', '')
      }

      // Abre o clicado se estava fechado
      if (!isOpen) {
        item.classList.add('open')
        btn.setAttribute('aria-expanded', 'true')
        answer.removeAttribute('hidden')
      }
    })
  }
})
